<template>
  <div ref="scroll" class="wrapper">
    <Navbar />
    <Body />
    <Footer v-if="!$route.meta.hideFooter" />
    <el-backtop target=".wrapper" :visibility-height="300" :bottom="150" :right="20"
      style="width: 50px;height: 50px;font-size: 15px;color:orangered;">
      <span style="font-size: 20px;">↑</span>顶部
    </el-backtop>
  </div>
</template>

<script>
import { Navbar, Footer, Body } from './components'

export default {
  name: 'Layout',
  components: {
    Navbar,
    Footer,
    Body
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="stylus" scoped>
.wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
  // height: 100%;
  min-height: 100%;
	min-width: BodyMaxWidth;
  background: #F9F9F9;
}

</style>
